import "core-js/modules/es.array.includes.js";
// 拥有：时段电价、策略配置、软件升级、参数设置权限
var whiteList = ['admin', 'SeanLiu', 'YafengWu', 'ConnorGao', 'zyt', 'lzr', 'bw'];

function isAdmin() {
  var userName = localStorage.getItem('currentUser_name');
  return whiteList.includes(userName);
}

export { isAdmin };